interface HeroSectionProps {
  onMainCta: () => void;
}

export default function HeroSection({ onMainCta }: HeroSectionProps) {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20fashion%20photography%20featuring%20colorful%20designer%20sneakers%20artfully%20arranged%20in%20asymmetrical%20geometric%20composition%20on%20pristine%20white%20marble%20surface%2C%20interspersed%20with%20premium%20leather%20bags%20and%20gold%20toned%20accessories%2C%20bright%20natural%20sunlight%20streaming%20from%20upper%20left%20creating%20crisp%20defined%20shadows%2C%20high%20contrast%20modern%20luxury%20aesthetic%2C%20premium%20product%20catalog%20photography%2C%20rich%20material%20textures%20and%20reflections%2C%20clean%20sophisticated%20composition%20with%20dynamic%20energy&width=1800&height=900&seq=hero-bg-kakobuy-fresh-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet fashion finds and product discovery"
          title="Kakobuy Spreadsheet - Fashion Finds Database"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-xs md:text-sm font-medium text-background-50/90 whitespace-nowrap">
            Updated Daily &bull; 10,000+ Organized Finds
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          Kakobuy Spreadsheet
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-4 leading-relaxed">
          The Ultimate Database For Finding Trending Products Faster
        </p>

        <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-10 leading-relaxed">
          Explore thousands of organized Kakobuy finds including sneakers, streetwear, fashion, accessories and more.
          Save time searching. Compare products. Discover verified finds.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Kakobuy Sheet
          </a>
          <button
            onClick={onMainCta}
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border-2 border-background-50/40 text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Explore Categories
          </button>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 text-base font-semibold hover:bg-accent-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
          {[
            { icon: 'ri-database-2-line', text: 'Updated Product Database' },
            { icon: 'ri-user-heart-line', text: 'Beginner Friendly Guides' },
            { icon: 'ri-stack-line', text: 'Organized Categories' },
            { icon: 'ri-shield-check-line', text: 'Shopping Safety Resources' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-background-50/75">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-sm`}></i>
              </div>
              <span className="text-xs md:text-sm whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}